import React from 'react';

import DriversRoutes from './drivers/routes';
import ShippersRoutes from './shippers/routes';

export default () => (
  <>
    <DriversRoutes key="DriversRoutes" />
    <ShippersRoutes key="ShippersRoutes" />
  </>
);
